export enum BasketballThreePointShotMadeAttribute {
  JumpShot = 650,
  PointsFromTurnovers = 728,
  SecondChancePoints = 729,
  FastBreakPoints = 730,
  Deep3 = 944,
  HalfCourt = 945,
  And1 = 946,
  StepBack = 947,
}
